import React, { useState } from "react";
import { useQuery } from "react-query";
import DataTable from "../../../components/shared/DataTable";
import Pagination from "../../../components/shared/Pagination";
import { formatDate, formatCurrency, statusBadgeClass } from "../../../utils/helpers";
import api from "../../../utils/api";

export default function PaymentHistory() {
  const [page, setPage] = useState(1);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const { data, isLoading } = useQuery(
    ["patient-payment-history", page, dateFrom, dateTo],
    () =>
      api.get(`/patient/payments?page=${page}&from=${dateFrom}&to=${dateTo}`),
    { keepPreviousData: true }
  );

  const columns = [
    { key: "transactionId", label: "Transaction ID" },
    { key: "description", label: "For" },
    {
      key: "amount",
      label: "Amount",
      render: (row) => formatCurrency(row.amount),
      sortable: true,
    },
    {
      key: "createdAt",
      label: "Date",
      render: (row) => formatDate(row.createdAt, "dd MMM yyyy, hh:mm a"),
      sortable: true,
    },
    {
      key: "status",
      label: "Status",
      render: (row) => (
        <span className={statusBadgeClass(row.status)}>{row.status}</span>
      ),
    },
  ];

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-3 items-end">
        <div>
          <label className="block text-xs font-semibold text-slate-500 mb-1 uppercase tracking-wide">From</label>
          <input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} className="input-field" />
        </div>
        <div>
          <label className="block text-xs font-semibold text-slate-500 mb-1 uppercase tracking-wide">To</label>
          <input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} className="input-field" />
        </div>
      </div>
      <DataTable
        columns={columns}
        data={data?.data || []}
        loading={isLoading}
        emptyMessage="No payment history yet."
      />
      <Pagination page={page} totalPages={data?.totalPages || 1} onPageChange={setPage} />
    </div>
  );
}
